var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(_vm.target),expression:"target"}],staticClass:"o-scroller",attrs:{"href":"#0"}},[_c('span',{staticClass:"o-scroller__icon"}),_c('span',{staticClass:"o-scroller__text"},[_vm._v("Scroll")])])
}
var staticRenderFns = []

export { render, staticRenderFns }